import * as Yup from 'yup';

const POSITIVE_DECIMAL_REGEX = /^\d+(\.\d+)?$/;

export const validationSchema = Yup.object().shape({
    members: Yup.array().of(
        Yup.object().shape({
            memberId: Yup.string().required('Member is required'),
            role: Yup.string().required('Role is required'),
            billableType: Yup.string().required('Billable type is required'),
            rateType: Yup.string().when('billableType', {
                is: 'billable',
                then: schema => schema.required('Rate type is required'),
                otherwise: schema => schema,
            }),
            employmentType: Yup.string().when('billableType', {
                is: 'billable',
                then: schema => schema.required('Employment type is required'),
                otherwise: schema => schema,
            }),
            currencyCode: Yup.string().required('Currency is required'),
            startDate: Yup.string().required('Start date is required'),
            rate: Yup.string().when('billableType', {
                is: 'billable',
                then: schema =>
                    schema.required('Rate is required').test('positive-rate', 'Rate must be a positive number', value => {
                        if (!value) return false;
                        const normalized = value.trim();
                        if (!POSITIVE_DECIMAL_REGEX.test(normalized)) return false;
                        return Number(normalized) > 0;
                    }),
                otherwise: schema => schema,
            }),
        })
    ),
    compensationIntervalStart: Yup.date().nullable(),
    compensationIntervalEnd: Yup.date().nullable(),
    compensationIntervalOpenEnded: Yup.boolean().required(),
});
